var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"800px"},attrs:{"src":_vm.url,"allowfullscreen":"allowfullscreen","frameborder":"0","data-id":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }